import { firestore } from 'api/firebaseApi';

// eslint-disable-next-line import/prefer-default-export
export const getConfig = async () => firestore.collection('config').get();
